<template>
	<v-dialog v-model="isVisible" max-width="750" persistent>
		<p-card class="tw-p-none overflow-hidden tw-relative">
			<div class="tw-flex tw-justify-center tw-py-3"
				:style="`color:${$appColors.primary};`">
				<h3>EVALUACIÓN</h3>
			</div>
			<div class="button-cls">
				<close-icon class="cursor-pointer" @click="close()"></close-icon>
			</div>
			<section class="evaluation-applicant tw-flex tw-flex-col tw-justify-between tw-gap-3 tw-p-6"
				v-for="(factor, indexF) in factors"
				:key="indexF">
				<div class="text-uppercase evaluation-applicant-header tw-px-6 tw-py-1 tw-flex tw-justify-between tw-mb-4">
					<span>{{ factor.name }} ({{ factor.score }} puntos)</span>
					<span class="tw-pl-48">{{ titleSection(factor) }}</span>
					<span>Puntaje Obtenido</span>
				</div>
				<div class="tw-flex tw-justify-between tw-items-center tw-px-2"
					v-for="(subfactor, indexSf) in factor.subFactors" :key="indexSf">
					<div style="width: 350px;" :style="`color:${$appColors.info};`">
						{{ subfactor.description }}
					</div>
					<input
						v-if="factor.flagInput"
						class="evaluation-applicant-input-time"
						type="number"
						:value="subfactor.valueTime ? subfactor.valueTime : ''"
						@input="insertTime(indexF, indexSf, { code: subfactor.code, scoreFactor: factor.score }, $event)">
					<input placeholder="Puntaje"
						class="evaluation-applicant-input"
						type="number"
						:readonly="factor.flagInput || factor.flagInterview"
						:value="subfactor.score ? subfactor.score : ''"
						@input="insertScore(indexF, indexSf, $event)">
				</div>
				<div class="total-evaluation tw-flex tw-justify-between tw-items-center tw-px-2 tw-pt-3">
					<div  :style="`color:${$appColors.secondary};`">
						Puntaje Obtenido
					</div>
					<input placeholder="Puntaje"
						readonly
						class="total-evaluation-input"
						:value="factor.totalScore > factor.score ? '' : factor.totalScore">
					<app-tooltip-button
						v-if="factor.totalScore > factor.score"
						class="total-evaluation-tooltip"
						text="El total del factor no debe superar los puntos establecidos"
						img="/static/img/info-alert.svg"
						disabled
					></app-tooltip-button>
				</div>
				<div class="ckeditor-container">
					<ckeditor :editor="editor" v-model="factor.comentary" :config="editorConfig" />
				</div>
			</section>
			<div class="tw-flex tw-justify-center tw-mb-3">
				<h3 :style="`color:${$appColors.info};`">Puntaje Acumulado: {{ totalScore }}</h3>
			</div>
			<div class="tw-flex tw-justify-center tw-items-center tw-pb-4">
				<p-button
					type="primary"
					:disabled="!validateValues || validatedScores || validateCommentaries"
					@click="saveEvaluationApplicant"
					>Guardar
				</p-button>
			</div>
		</p-card>
	</v-dialog>
</template>

<script>
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PButton from '@/modules/shared/components/ui/p-button';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CloseIcon from '@/modules/shared/components/icons/close-icon';
import helper from '@/shared/helper';

const { calculateExperience, calculateTraining, roundTo } = helper;

export default {
	name: 'evaluation-applicant-dialog',
	beforeCreate() {
	},
	created() {
	},
	mounted() {
	},
	data() {
		return {
			isVisible: false,
			editor: ClassicEditor,
			editorData: '',
			editorConfig: {
				toolbar: {
					shouldNotGroupWhenFull: true,
					items: ['undo', 'redo', 'heading', 'bold', 'italic', 'bulletedList', 'numberedList'],
				},
				image: {
					uploadEnabled: false,
					toolbar: ['imageTextAlternative'],
				},
				table: {
					contentToolbar: [],
				},
			},
		};
	},
	components: { PButton, PCard, CloseIcon },
	methods: {
		open() {
			this.isVisible = true;
		},
		close() {
			this.isVisible = false;
		},
		insertTime(indexF, indexSf, { code, scoreFactor }, dataInput) {
			try {
				const valueInput = Number(dataInput.target.value);
				let response = null;
				if (code === 'EXA' || code === 'EXB' || code === 'EXC') {
					const words = this.experienceTime.code.split('-');
					const numberData = Number(words[0]);
					const textData = words[1];
					const months = textData === 'A' ? numberData * 12 : numberData;
					const valueTable = 100 / months;
					response = calculateExperience(valueTable, code, valueInput);
				} else {
					const valueTableTrainig = 100 / 200;
					response = calculateTraining(valueTableTrainig, code, valueInput);
				}
				this.factors[indexF].subFactors[indexSf].score = response;
				this.factors[indexF].subFactors[indexSf].valueTime = valueInput;
				this.$set(this.factors[indexF].subFactors, indexSf, {
					...this.factors[indexF].subFactors[indexSf],
					score: response,
				});
				this.updateTotalScore(indexF);
				const totalScoreCalc = roundTo((this.calculateTotalScore(
					this.factors[indexF].subFactors) * scoreFactor) / 100, 2);
				this.$set(this.factors, indexF, {
					...this.factors[indexF],
					totalScore: totalScoreCalc > scoreFactor ? scoreFactor : totalScoreCalc,
				});
				this.$forceUpdate();
			} catch (error) {
				this.showGenericError();
			}
		},
		insertScore(indexF, indexSf, scoreSubFactor) {
			this.factors[indexF].subFactors[indexSf].score = scoreSubFactor.target.value;
			this.$set(this.factors[indexF].subFactors, indexSf, {
				...this.factors[indexF].subFactors[indexSf],
				score: scoreSubFactor.target.value,
			});
			this.updateTotalScore(indexF);
			this.$set(this.factors, indexF, {
				...this.factors[indexF],
				totalScore: this.calculateTotalScore(this.factors[indexF].subFactors),
			});
			this.$forceUpdate();
		},
		updateTotalScore(indexF) {
			this.$set(this.factors, indexF, {
				...this.factors[indexF],
				totalScore: this.calculateTotalScore(this.factors[indexF].subFactors),
			});
		},
		calculateTotalScore(subFactors) {
			return subFactors.reduce((acum, sf) => {
				let add = acum;
				add += sf.score ? Number(sf.score) : 0;
				return add;
			}, 0);
		},
		calculatePercentage(totalPercentage, scoreFactor) {
			const total = (totalPercentage * scoreFactor) / 100;
			return total > scoreFactor ? scoreFactor : roundTo(total, 2);
		},
		saveEvaluationApplicant() {
			this.$emit('saveEvaluationApplicant', this.factors);
			this.close();
		},
		subFactorsHaveScores(factors) {
			if (!Array.isArray(factors) || !factors[0].subFactors) {
				this.showNotification('El candidato aún no ha sido Entrevistado', 'warning');
			} else {
				return factors.every((factor) => {
					const factorScoreDefined = factor.score && factor.score !== undefined && factor.score !== '';
					const subFactorsScoreDefined = factor.subFactors.every(subFactor => subFactor.score !== undefined && subFactor.score !== '');

					return factorScoreDefined && subFactorsScoreDefined;
				});
			}
			return false;
		},
		titleSection(factor) {
			if (factor.name === 'EXPERIENCIA') {
				return 'MESES';
			} else if (factor.name === 'CAPACITACIÓN') {
				return 'HORAS';
			}
			return '';
		},
	},
	computed: {
		validateValues() {
			return this.subFactorsHaveScores(this.factors);
		},
		validatedScores() {
			const resultado = this.factors.some(factor => factor.totalScore > factor.score);
			return resultado;
		},
		validateCommentaries() {
			const noCommentary = this.factors
				.some(dt => !dt.comentary || dt.comentary === null || dt.comentary.trim() === '');
			return noCommentary;
		},
		totalScore() {
			const totalScoreSum = Array.isArray(this.factors) ?
				this.factors.reduce((sum, factor) => sum + (factor.totalScore || 0), 0) : 0;
			return roundTo(totalScoreSum, 2);
		},
	},
	props: {
		factors: {
			type: [Array, Object],
			default: () => [],
		},
		experienceTime: {
			type: Object,
			default: {},
		},
	},
	watch: {
	},
};
</script>

<style lang="scss" scoped>
.evaluation-applicant {
	width: 100%;
	&-input-time {
		background: map-get($colors, white);
		border: 1px solid map-get($colors, green-dark);
		border-radius: 4px;
		display: block;
		outline: none;
		color: map-get($colors, gray-sidebar);
		padding: 5px 10px;
		width: 80px;
		text-align: center;

		&::placeholder {
			color: map-get($colors, placeholder);
			text-align: center;
		}
	}
	&-input {
		background: map-get($colors, white);
		border: 1px solid map-get($colors, green-dark);
		border-radius: 4px;
		display: block;
		outline: none;
		color: map-get($colors, gray-sidebar);
		padding: 5px 20px;
		width: 120px;
		text-align: center;

		&::placeholder {
			color: map-get($colors, placeholder);
			text-align: center;
		}
	}
	&-header {
		background-color: var(--app-color-primary);
		border-radius: 5px;
		span {
			color: white !important;
			font-weight: bold;
		}
	}
}
.total-evaluation {
	position: relative;
	border-top: 2px solid color(orange-dark);
	&-input {
		background: map-get($colors, white);
		border: 1px solid map-get($colors, orange-dark);
		border-radius: 4px;
		display: block;
		outline: none;
		color: map-get($colors, gray-sidebar);
		padding: 5px 20px;
		width: 120px;
		text-align: center;
		box-sizing: border-box;

		&::placeholder {
			color: map-get($colors, placeholder);
			text-align: center;

		}
	}
	&-tooltip {
		position: absolute;
		top: 5px;
		right: -10px;
		height: 100%;
		display: flex;
		align-items: center;
		padding: 0 10px;
		cursor: pointer;
		border: none;
		background: none;
	}
}
.ckeditor-container {
	max-height: 20vh;
	overflow: auto;
	color: color(gray-sidebar);
}
.button-cls {
	position: absolute;
	right: 15px;
	top: 15px;
}
</style>


// WEBPACK FOOTER //
// src/modules/recruitment/components/content/evaluation-applicant-dialog.vue